import Header from "../components/header/Header";

const Navbar = () => <Header />;

export default Navbar;
